import { Trans } from '@lingui/macro'
import classnames from 'classnames'
import Link from 'next/link'
import React, { FC } from 'react'

import { toQAUrl } from '../../utils/slug'
import { CustomisedFeedObjectQuestion } from '../NewQuestion'
import styles from './ChannelQuestion.module.css'

type Props = {
  item: CustomisedFeedObjectQuestion
  className?: string
}

const QuestionComponent: FC<Props> = ({ item, className }: Props) => {
  if (!item.questionText.value) {
    return null
  }
  const relativeLink = toQAUrl(item.slug, item.id)

  return (
    <div key={item.id} className={classnames(styles.articleWrapper, className)}>
      <div className={styles.channelArticleWrapper}>
        <div className={styles.articleTitle}>{item.questionText.value}</div>
        <div className={styles.articleAnswerCount}>
          <Trans>{item.answerCount} Answers</Trans>
        </div>
        <hr className={styles.articleDivisionLine} />
        {item.userData && (
          <div className={styles.articleAnswerAuthor}>
            <div>
              <img src={item.userData.profilePicUrl} className={styles.articleAnswerProfilePic} alt={''} />
            </div>
            <div className={styles.articleAnswerAuthorName}>
              <span>{item.userData.fullName}</span>
            </div>
          </div>
        )}
        <div className={styles.articleAnswerDescription}>{item.blogAnswer}</div>
        <Link href={relativeLink}>
          <a className={styles.articleAnswerReadMore}>
            <Trans>Read More</Trans>
          </a>
        </Link>
      </div>
    </div>
  )
}

export default QuestionComponent
